import { injectIntl, IntlShape } from 'react-intl';
import { Box } from '@material-ui/core';
import { get, isEmpty, uniqueId } from 'lodash';
import {
  StyledBeneficiaryTitle,
  StyledDeceasedData,
  StyledRecapData,
  StyledRecapTitle,
} from 'containers/CourtManagerLegalProceedings/Provision/styled-components';
import { translate } from 'containers/services/translate';
import { resolveLabel } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';
import { Beneficiary, Victim } from 'containers/PreOpeningPage/typings';
import { Listings } from 'containers/AppContainer/typings';
import { getRisks } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import { RISK_NAME } from 'containers/CourtManagerLegalProceedings/Provision/constants';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import { ClaimRecapType } from 'typings/claimTypes';

export interface SideRegulationVictimDetailsProps {
  intl: IntlShape;
  sagisClaim: any;
  claimRecap: ClaimRecapType;
  riskRecap: any;
  listings: Listings;
  substituteDocumentNature: any;
  showRegulationJudgement: boolean;
  height: number;
  risk: any;
}

export const SideRegulationVictimDetails: React.FC<SideRegulationVictimDetailsProps> = ({
  sagisClaim,
  claimRecap,
  riskRecap,
  listings,
  substituteDocumentNature,
  showRegulationJudgement,
  height,
  risk,
  ...props
}): JSX.Element => {
  const { rcCorpo } = getRisks(riskRecap);

  const injuredVictims = get(rcCorpo, 'data', []).filter(
    (victim: Victim) => victim.injuryPostKey !== INJURY_POST_DECEASED,
  );
  const deceasedVictims = get(rcCorpo, 'data', []).filter(
    (victim: Victim) => victim.injuryPostKey === INJURY_POST_DECEASED,
  );

  return (
    <>
      {risk.riskName !== RISK_NAME.CORPOREAL && (
        <>
          <div>
            <StyledRecapTitle>
              {!isEmpty(get(risk, 'data', [])) && risk['primaryMessage']}
            </StyledRecapTitle>
          </div>
          {get(risk, 'data', []).map((el: any) => (
            <div key={get(el, 'id', uniqueId())}>
              <StyledRecapData isColored={false}>
                {resolveLabel(el)}
              </StyledRecapData>
            </div>
          ))}
        </>
      )}
      {risk.riskName === RISK_NAME.CORPOREAL && (
        <>
          {!isEmpty(injuredVictims) && (
            <>
              <div>
                {
                  <StyledRecapTitle>
                    {!isEmpty(injuredVictims) &&
                      translate(messages.injuredVictims, props)}
                  </StyledRecapTitle>
                }
              </div>
              {injuredVictims.map((el: any) => (
                <div key={get(el, 'id', uniqueId())}>
                  <StyledRecapData isColored={false}>
                    {resolveLabel(el)}
                  </StyledRecapData>
                </div>
              ))}
            </>
          )}
          <div>
            <div>
              <StyledRecapTitle>
                {!isEmpty(deceasedVictims) &&
                  translate(messages.deceasedVictims, props)}
              </StyledRecapTitle>
            </div>
            <div>
              {deceasedVictims.map((el: any) => (
                <Box className="box-field" key={el.id}>
                  <div key={get(el, 'id', uniqueId())}>
                    <span className="victim-el">Victime</span>
                    <StyledDeceasedData>{resolveLabel(el)}</StyledDeceasedData>
                  </div>
                  {!isEmpty(get(el, 'beneficiaries', [])) && (
                    <div className="beneficiary-items">
                      <StyledBeneficiaryTitle>
                        {translate(messages.beneficiariesTitle, props)}
                      </StyledBeneficiaryTitle>
                      <div className="item-row">
                        {get(el, 'beneficiaries', []).map(
                          (beneficiary: Beneficiary) => {
                            return (
                              <StyledDeceasedData className="item">
                                {resolveLabel(beneficiary)}
                              </StyledDeceasedData>
                            );
                          },
                        )}
                      </div>
                    </div>
                  )}
                </Box>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default injectIntl(SideRegulationVictimDetails);
